<template>
  <el-dialog
    title="附件管理"
    :visible.sync="dialogVisible"
    width="85%"
    :close-on-click-modal="false"
    @close="handleClose"
    class="file-dialog"
    top="3vh"
  >
    <div class="file-dialog-content">
      <!-- ====== 产证信息 ====== -->
      <div class="file-section">
        <div class="section-header">
          <span class="section-title">产证信息</span>
          <el-button type="primary" size="small" icon="el-icon-upload2" @click="openUploadDialog('产证信息')">
            添加产证信息
          </el-button>
        </div>
        <el-table :data="fileGroups['产证信息']" border stripe v-loading="loading" size="small">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
          <el-table-column label="预览" width="150" align="center">
            <template slot-scope="{ row }">
              <div v-if="isImage(row.suffix)" class="preview-thumbnail">
              
                 <el-image
                    :src="row.show_path_full"
                    fit="cover"
                    style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                    :preview-src-list="[row.show_path_full]"
                  />
              </div>
              <span v-else class="preview-placeholder">仅支持图片预览</span>
            </template>
          </el-table-column>
          <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
          <el-table-column label="操作" width="220" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" size="mini" @click="handleView(row)">查看</el-button>
              <el-button type="text" size="mini" @click="handleDownload(row)">下载</el-button>
              <el-button type="text" size="mini" style="color: #f56c6c;" @click="handleDelete(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!fileGroups['产证信息'] || fileGroups['产证信息'].length === 0" class="empty-tip">
          暂无产证信息文件
        </div>
      </div>

      <!-- ====== 身份证信息 ====== -->
      <div class="file-section">
        <div class="section-header">
          <span class="section-title">身份证信息</span>
          <el-button type="primary" size="small" icon="el-icon-upload2" @click="openUploadDialog('身份证信息')">
            添加身份证信息
          </el-button>
        </div>
        <el-table :data="fileGroups['身份证信息']" border stripe v-loading="loading" size="small">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
          <el-table-column label="预览" width="150" align="center">
            <template slot-scope="{ row }">
              <div v-if="isImage(row.suffix)" class="preview-thumbnail">
                <el-image
                    :src="row.show_path_full"
                    fit="cover"
                    style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                    :preview-src-list="[row.show_path_full]"
                  />
              </div>
              <span v-else class="preview-placeholder">仅支持图片预览</span>
            </template>
          </el-table-column>
          <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
          <el-table-column label="操作" width="220" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" size="mini" @click="handleView(row)">查看</el-button>
              <el-button type="text" size="mini" @click="handleDownload(row)">下载</el-button>
              <el-button type="text" size="mini" style="color: #f56c6c;" @click="handleDelete(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!fileGroups['身份证信息'] || fileGroups['身份证信息'].length === 0" class="empty-tip">
          暂无身份证信息文件
        </div>
      </div>

      <!-- ====== 房屋原貌 ====== -->
      <div class="file-section">
        <div class="section-header">
          <span class="section-title">房屋原貌</span>
          <el-button type="primary" size="small" icon="el-icon-upload2" @click="openUploadDialog('房屋原貌')">
            添加房屋原貌
          </el-button>
        </div>
        <el-table :data="fileGroups['房屋原貌']" border stripe v-loading="loading" size="small">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
          <el-table-column prop="type_2" label="分类" width="100" align="center">
            <template slot-scope="{ row }">
              <el-tag size="small">{{ row.type_2 || '-' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="预览" width="150" align="center">
            <template slot-scope="{ row }">
              <div v-if="isImage(row.suffix)" class="preview-thumbnail">
               <el-image
                    :src="row.show_path_full"
                    fit="cover"
                    style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                    :preview-src-list="[row.show_path_full]"
                  />
              </div>
              <span v-else class="preview-placeholder">仅支持图片预览</span>
            </template>
          </el-table-column>
          <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
          <el-table-column label="操作" width="220" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" size="mini" @click="handleView(row)">查看</el-button>
              <el-button type="text" size="mini" @click="handleDownload(row)">下载</el-button>
              <el-button type="text" size="mini" style="color: #f56c6c;" @click="handleDelete(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!fileGroups['房屋原貌'] || fileGroups['房屋原貌'].length === 0" class="empty-tip">
          暂无房屋原貌文件
        </div>
      </div>

      <!-- ====== 房屋托管合同信息 ====== -->
      <div class="file-section">
        <div class="section-header">
          <span class="section-title">房屋托管合同信息</span>
          <el-button type="primary" size="small" icon="el-icon-upload2" @click="openUploadDialog('房屋托管合同信息')">
            添加房屋托管合同信息
          </el-button>
        </div>
        <el-table :data="fileGroups['房屋托管合同信息']" border stripe v-loading="loading" size="small">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
          <el-table-column label="预览" width="150" align="center">
            <template slot-scope="{ row }">
              <div v-if="isImage(row.suffix)" class="preview-thumbnail">
                <el-image
                    :src="row.show_path_full"
                    fit="cover"
                    style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                    :preview-src-list="[row.show_path_full]"
                  />
              </div>
              <span v-else class="preview-placeholder">仅支持图片预览</span>
            </template>
          </el-table-column>
          <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
          <el-table-column label="操作" width="220" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" size="mini" @click="handleView(row)">查看</el-button>
              <el-button type="text" size="mini" @click="handleDownload(row)">下载</el-button>
              <el-button type="text" size="mini" style="color: #f56c6c;" @click="handleDelete(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!fileGroups['房屋托管合同信息'] || fileGroups['房屋托管合同信息'].length === 0" class="empty-tip">
          暂无房屋托管合同信息文件
        </div>
      </div>

      <!-- ====== 委托授权书 ====== -->
      <div class="file-section">
        <div class="section-header">
          <span class="section-title">委托授权书</span>
          <el-button type="primary" size="small" icon="el-icon-upload2" @click="openUploadDialog('委托授权书')">
            添加委托授权书
          </el-button>
        </div>
        <el-table :data="fileGroups['委托授权书']" border stripe v-loading="loading" size="small">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
          <el-table-column label="预览" width="150" align="center">
            <template slot-scope="{ row }">
              <div v-if="isImage(row.suffix)" class="preview-thumbnail">
                <el-image
                    :src="row.show_path_full"
                    fit="cover"
                    style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                    :preview-src-list="[row.show_path_full]"
                  />
              </div>
              <span v-else class="preview-placeholder">仅支持图片预览</span>
            </template>
          </el-table-column>
          <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
          <el-table-column label="操作" width="220" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" size="mini" @click="handleView(row)">查看</el-button>
              <el-button type="text" size="mini" @click="handleDownload(row)">下载</el-button>
              <el-button type="text" size="mini" style="color: #f56c6c;" @click="handleDelete(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="!fileGroups['委托授权书'] || fileGroups['委托授权书'].length === 0" class="empty-tip">
          暂无委托授权书文件
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </span>

    <!-- ====== 上传文件弹窗 ====== -->
    <el-dialog
      :title="uploadDialog.title"
      :visible.sync="uploadDialog.visible"
      width="520px"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="resetUploadForm"
    >
      <el-form :model="uploadForm" label-width="100px" size="small">
        <el-form-item label="选择文件" required>
          <el-upload
            ref="uploadRef"
            :auto-upload="false"
            :limit="1"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            action="#"
            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx"
          >
            <el-button size="small" type="primary">点击选择文件</el-button>
            <span slot="tip" class="el-upload__tip">支持 jpg、jpeg、png、pdf、doc、docx、xls、xlsx</span>
          </el-upload>
          <div v-if="uploadForm.fileName" style="margin-top: 8px; font-size: 13px; color: #409EFF;">
            已选择：{{ uploadForm.fileName }}
          </div>
        </el-form-item>

        <el-form-item v-if="uploadForm.showType2" label="二级分类">
          <el-select v-model="uploadForm.type_2" placeholder="请选择分类" style="width:100%">
            <el-option label="客厅" value="客厅" />
            <el-option label="卧室" value="卧室" />
            <el-option label="厨房" value="厨房" />
            <el-option label="卫生间" value="卫生间" />
            <el-option label="其他" value="其他" />
          </el-select>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="uploadForm.bz" placeholder="请输入备注（可选）" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="uploadDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="handleUploadSubmit" :loading="uploading">确认</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { fileMethod } from '@/api/files/fileMethod'

export default {
  name: 'SfHouseFile',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    fatherId: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      dialogVisible: false,
      loading: false,
      uploading: false,

      // 文件分组数据
      fileGroups: {
        '产证信息': [],
        '身份证信息': [],
        '房屋原貌': [],
        '房屋托管合同信息': [],
        '委托授权书': []
      },

      // 上传弹窗
      uploadDialog: {
        visible: false,
        title: '添加文件'
      },

      uploadForm: {
        file: null,
        fileName: '',
        type_1: '',
        type_2: '',
        bz: '',
        showType2: false
      },

      currentType1: ''
    }
  },

  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val
        console.log('visible 变化:', val, 'fatherId:', this.fatherId)
        // 弹窗打开时加载数据
        if (val) {
          this.loadAllFiles()
        }
      },
      immediate: true
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },

  methods: {
    // ====== 判断是否为图片 ======
    isImage(suffix) {
      if (!suffix) return false
      const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      return imageTypes.includes(suffix.toLowerCase())
    },

// ====== 加载所有文件 ======
async loadAllFiles() {
  if (!this.fatherId) {
    console.warn('fatherId 为空，无法加载文件')
    return
  }

  if (this.loading) return

  this.loading = true
  const type1List = ['产证信息', '身份证信息', '房屋原貌', '房屋托管合同信息', '委托授权书']

  console.log('开始加载文件，fatherId:', this.fatherId)
  const fatherId = String(this.fatherId)

  // 从配置文件获取 fileBaseUrl，如果不存在则使用默认值
  const fileBaseUrl = window.applicationConfig?.fileBaseUrl || window.location.origin + '/nngy/'

  try {
    const promises = type1List.map(type1 => {
      return fileMethod.listFiles('房源', fatherId, type1, null)
        .then(res => {
          console.log(`${type1} 返回:`, res)
          if (res.code === 200) {
            let data = res.data?.list || []
            // ====== 使用 fileBaseUrl 拼接完整 URL ======
            data = data.map(item => {
              if (item.show_path) {
                // 如果已经是完整 URL，直接使用；否则用 fileBaseUrl 拼接
                const isFullUrl = item.show_path.startsWith('http://') || item.show_path.startsWith('https://')
                // 去掉 show_path 开头的 /，避免双斜杠
                const cleanPath = item.show_path.replace(/^\//, '')
                item.show_path_full = isFullUrl ? item.show_path : fileBaseUrl + cleanPath
                console.log('拼接后的图片URL:', item.show_path_full)  // 调试日志
              } else {
                item.show_path_full = ''
              }
              return item
            })
            return { type1, data }
          }
          return { type1, data: [] }
        })
        .catch(err => {
          console.error(`加载 ${type1} 失败:`, err)
          return { type1, data: [] }
        })
    })

    const results = await Promise.all(promises)
    results.forEach(({ type1, data }) => {
      this.fileGroups[type1] = data
    })

    console.log('文件加载完成:', this.fileGroups)
  } catch (error) {
    console.error('加载文件失败:', error)
    this.$message.error('加载文件失败')
  } finally {
    this.loading = false
  }
},
    // ====== 打开上传弹窗 ======
    openUploadDialog(type1) {
      this.currentType1 = type1
      this.uploadDialog.title = `添加${type1}`
      this.uploadDialog.visible = true

      this.uploadForm.file = null
      this.uploadForm.fileName = ''
      this.uploadForm.type_1 = type1
      this.uploadForm.type_2 = ''
      this.uploadForm.bz = ''
      this.uploadForm.showType2 = type1 === '房屋原貌'

      this.$nextTick(() => {
        if (this.$refs.uploadRef) {
          this.$refs.uploadRef.clearFiles()
        }
      })
    },

    // ====== 文件选择变化 ======
    handleFileChange(file) {
      this.uploadForm.file = file.raw
      this.uploadForm.fileName = file.name
    },

    // ====== 文件移除 ======
    handleFileRemove() {
      this.uploadForm.file = null
      this.uploadForm.fileName = ''
    },

    // ====== 重置上传表单 ======
    resetUploadForm() {
      this.uploadForm.file = null
      this.uploadForm.fileName = ''
      this.uploadForm.type_2 = ''
      this.uploadForm.bz = ''
      this.uploading = false
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles()
      }
    },

    // ====== 上传提交 ======
    async handleUploadSubmit() {
      if (!this.uploadForm.file) {
        this.$message.warning('请选择文件')
        return
      }

      if (this.currentType1 === '房屋原貌' && !this.uploadForm.type_2) {
        this.$message.warning('请选择二级分类')
        return
      }

      this.uploading = true

      try {
        const res = await fileMethod.uploadFile(
          this.uploadForm.file,
          '房源',
          this.fatherId,
          this.uploadForm.type_1,
          this.uploadForm.type_2 || '',
          this.uploadForm.bz || ''
        )

        console.log('上传返回:', res)

        if (res.code === 200) {
          this.$message.success('上传成功')
          this.uploadDialog.visible = false
          // 重新加载所有文件
          await this.loadAllFiles()
        } else {
          this.$message.error(res.message || '上传失败')
        }
      } catch (error) {
        console.error('上传失败:', error)
        this.$message.error(error.message || '上传失败，请稍后重试')
      } finally {
        this.uploading = false
      }
    },

   // ====== 查看文件 ======
handleView(row) {
  // 优先使用 show_path_full，其次使用 show_path
  const url = row.show_path_full || row.show_path
  if (url) {
    // 如果 url 是相对路径，拼接 fileBaseUrl
    if (url.startsWith('/')) {
      const fileBaseUrl = window.applicationConfig?.fileBaseUrl || window.location.origin + '/nngy/'
      window.open(fileBaseUrl + url.replace(/^\//, ''), '_blank')
    } else {
      window.open(url, '_blank')
    }
  } else {
    this.$message.warning('文件路径不存在')
  }
},

    // ====== 下载文件 ======
    // 在 methods 中添加
handleDownload(row) {
  // 显示加载提示
  const loading = this.$loading({
    lock: true,
    text: '正在下载文件...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  
  fileMethod.downloadFile(row.show_path)
    .then(response => {
      loading.close()
      
      // 创建 Blob 对象
      const blob = new Blob([response.data])
      
      // 创建下载链接
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = row.show_name || '下载文件'
      
      // 触发下载
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      // 释放 URL
      URL.revokeObjectURL(link.href)
      
      this.$message.success('下载成功')
    })
    .catch(error => {
      loading.close()
      console.error('下载失败:', error)
      this.$message.error('下载失败，请重试')
    })
},

    // ====== 删除文件 ======
    async handleDelete(row) {
      console.log("row====",row)
      try {
        await this.$confirm(
          `确认删除文件 "${row.show_name}" 吗？删除后不可撤回！`,
          '提示',
          {
            type: 'warning',
            confirmButtonText: '确认删除',
            cancelButtonText: '取消'
          }
        )

        console.log('删除文件，id:', row.id)

        const res = await fileMethod.deleteFile(row.id)
        console.log('删除返回:', res)

        if (res.code === 200 && res.data?.deleted) {
          this.$message.success('删除成功')
          // 重新加载所有文件
          await this.loadAllFiles()
        } else {
          this.$message.warning(res.data?.message || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error)
          this.$message.error(error.message || '删除失败，请稍后重试')
        }
      }
    },

    // ====== 关闭弹窗 ======
    handleClose() {
      this.dialogVisible = false
    },

    // ====== 刷新数据（外部调用） ======
    refresh() {
      console.log('外部调用 refresh')
      this.loadAllFiles()
    },
     getFullUrl(path) {
    if (!path) return ''
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path
    }
    // 拼接协议、域名、端口
    const base = window.location.origin
    return base + path
  }
  }
}
</script>

<style scoped>
.file-dialog /deep/ .el-dialog {
  max-height: 92vh;
  display: flex;
  flex-direction: column;
}

.file-dialog /deep/ .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 20px 20px 10px 20px;
}

.file-dialog /deep/ .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding: 12px 20px;
}

.file-dialog-content {
  height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
}

.file-dialog-content::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.file-dialog-content::-webkit-scrollbar-track {
  background: #f0f2f5;
  border-radius: 3px;
}

.file-dialog-content::-webkit-scrollbar-thumb {
  background: #c1c7cd;
  border-radius: 3px;
}

.file-dialog-content::-webkit-scrollbar-thumb:hover {
  background: #a8b0b8;
}

.file-dialog-content {
  scrollbar-width: thin;
  scrollbar-color: #c1c7cd #f0f2f5;
}

.file-section {
  margin-bottom: 28px;
}

.file-section:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  margin-bottom: 12px;
  border-bottom: 2px solid #409EFF;
  position: relative;
}

.section-header::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 60px;
  height: 2px;
  background: #409EFF;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.preview-thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-placeholder {
  font-size: 12px;
  color: #909399;
}

.empty-tip {
  text-align: center;
  padding: 16px 0;
  color: #909399;
  font-size: 13px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-top: 4px;
}

@media (max-width: 768px) {
  .file-dialog /deep/ .el-dialog {
    width: 95% !important;
  }

  .file-dialog-content {
    height: 50vh;
  }

  .section-header {
    flex-wrap: wrap;
    gap: 8px;
  }

  .section-header .el-button {
    margin-left: auto;
  }
}
</style>